import ResultsServiceCollection from '../ResultsServiceCollection'
import SampleModel from '../../models/result/SampleModel'

/**
 * Sample collection
 */
export default class SampleCollection extends ResultsServiceCollection {

  // Model that is contained in this collection.
  model () {
    return SampleModel
  }

  getModelsFromResponse (response) {
    const models = []
    const { data } = response.getData()

    if (data.pagination) {
      this.set('count', data.pagination.total)
    }

    if (data.samples) {
      data.samples.forEach((insert) => {
        const temp = (new (this.model())(insert))
        models.push(temp)
      })
    }

    return models
  }

}
